import * as React from 'react'
import { FilterChip } from './FilterChip'
import { ClearAllButton } from './ClearAllButton'
import { useHandlers, useListData } from './hooks'
import type { IFilterChipListProps, IFilterSet } from '../typings'
import { useSelector } from 'react-redux/es/hooks/useSelector'
import Stack from '@mui/material/Stack'
import { selectAllSalesTeams } from '@user/store/salesTeam/slice'

export function FilterChipList<U, T extends IFilterSet<U>>(
  props: IFilterChipListProps<T>,
) {
  const { clearedFilters, entityType, width } = props

  const salesTeams = useSelector(selectAllSalesTeams)

  const { validKeys } = useListData()
  const { clearAll, onDeleteChip } = useHandlers<U, T>(clearedFilters)

  return (
    <Stack
      flexDirection="row"
      justifyContent="flex-end"
      width={width || '100%'}
    >
      <Stack
        pt={0.5}
        ml="auto"
        flexWrap="wrap"
        alignItems="flex-end"
        justifyContent="flex-end"
        flexDirection="row"
        width="90%"
      >
        {validKeys.map((item, index) => (
          <FilterChip<U, T>
            key={index}
            entityType={entityType}
            filterId={item.toString()}
            onDeleteChip={onDeleteChip}
            salesTeamCount={salesTeams.length}
          />
        ))}
      </Stack>
      <Stack
        maxHeight={26}
        lineHeight={26}
        fontSize={15}
        alignItems="flex-start"
      >
        <ClearAllButton clearAll={clearAll} />
      </Stack>
    </Stack>
  )
}
